import { DialogProgrammatic as Dialog } from 'buefy'
import { escapeHTML } from '../static/socap_helpers'
import { getGraphql } from '../static/graphql/getGraphql'
const getUserNameFromGroupMember = (member) => {
  if (member.meta.user_name) {
    return member.meta.user_name
  }
  return member.name
}

export const state = () => ({
  loading: [],
  env: process.env.DEV_ENV,
  groups: undefined,
  GRAPHQL_URL: process.env.GRAPHQL_URL, // TBD : landing zone implementation to be worked
  INVITE_CODES_URL: process.env.INVITE_CODES_URL, // TBD : landing zone implementation to be worked
  groupMembers: [],
  invites: [],
  newInvite: '',
  textSent: '',
  requestFailure: false,
  code: '',
  NOTIFICATIONS_URL: process.env.NOTIFICATIONS_URL, // TBD : landing zone implementation to be worked
  LANDING_URL: process.env.LANDING_URL,
  loadSocialResponse: null,
  inviteGroupSearchResponse: null,
})

/*
 *  Attempt to parse poorly formatted string into JSON.
 *  TODO: move this into a reusable helper function
 */
function parseIt(stringToParse, that) {
  let ret
  try {
    if (typeof stringToParse === 'object' && stringToParse !== null) {
      // already an object, no need to parse
      ret = stringToParse
    } else {
      // this is not an object.  attempt to parse it
      ret = that.$JSON5.parse(that.$JSON5.parse(stringToParse))
    }
  } catch (error) {
    // last ditch effort to parse it
    ret = that.$JSON5.parse(stringToParse)
  }
  return ret
}

export const mutations = {
  setSocialResponse(state, payload) {
    // Parse meta.  It comes back double-escaped. :(
    const socialGroups = payload.data.me.relationships?.socialGroups
    socialGroups.forEach((group) => {
      group.meta = parseIt(group.meta, this)
      group.cadence = group?.meta?.cadence
      group.purpose = group?.meta?.purpose

      // Parse meta.  It comes back double-escaped. :(
      const groupMembers = {}
      group.relationships.hasMember.forEach((member) => {
        member.meta = parseIt(member.meta, this)
        groupMembers[member.entityUuid] = getUserNameFromGroupMember(member)
      })

      // get latest posts
      group.contributions.forEach((item) => {
        item.type = 'contribution'
        const itemDate = new Date(item.dateCreated)
        const itemDateUtc = new Date(`${itemDate.toString()} UTC`)
        item.tstamp = itemDateUtc
        item.createdByEntityUserName = groupMembers[item.entityUuid]
        item.postUuid = item.socialContributionUuid
      })
      group.asks.forEach((item) => {
        item.type = 'ask'
        const itemDate = new Date(item.dateCreated)
        const itemDateUtc = new Date(`${itemDate.toString()} UTC`)
        item.tstamp = itemDateUtc
        item.createdByEntityUserName = groupMembers[item.entityUuid]
        item.postUuid = item.socialAskUuid
      })

      // combine asks and contributions and sort by tstamp
      group.latestPosts = [...group.contributions.concat(group.asks)].sort(
        (a, b) => b.tstamp - a.tstamp
      )
      for (let i = 0; i < group.latestPosts.length; i++) {
        group.latestPosts[i].createdByEntityUserName =
          groupMembers[group.latestPosts[i].createdByEntityUuid]
      }
    })

    state.loadSocialResponse = payload
  },
  setInviteGroupSearchResponse(state, payload) {
    state.inviteGroupSearchResponse = payload
  },
  setWindowSize(state, w) {
    state.windowHeight = w.innerHeight
    state.windowWidth = w.innerWidth
  },
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  removeGroup(state, groupSlug) {
    const groups = state.loadSocialResponse.data.me.relationships?.socialGroups
    for (let i = 0; i < groups.length; i++) {
      if (groups[i].slug === groupSlug) {
        groups.splice(i, 1)
      }
    }
  },
  setTextStatus(state, payload) {
    state.textSent = payload
  },
  setRequestFailure(state) {
    state.requestFailure = true
  },
  reset(state) {
    state.loading = []
    state.groups = undefined
    state.groupMembers = []
    state.invites = []
    state.newInvite = ''
    state.textSent = ''
    state.requestFailure = false
  },
  setCodeData(state, payload) {
    // deprecated
    if (payload !== null) {
      state.inviteCodeData = payload
    } else {
      state.inviteCodeData = { message: 'failure' }
    }
  },
  clearCodeData(state) {
    // deprecated
    state.inviteCodeData = null
  },
  setNewInvite(state, payload) {
    state.newInvite = payload.data.data.me.inviteCodes.createInviteCodes.code
  },
  clearInvite(state) {
    state.newInvite = ''
  },
  clearInvites(state) {
    state.invites = []
  },
  setInvites(state, payload) {
    const codes = payload.data.data.me.inviteCodes
    state.invites = []
    for (let i = 0; i < codes.length; i++) {
      const x = codes[i].replace(/None/g, '"none"')
      const code = x.replace(/'/g, '"')
      state.invites.push(JSON.parse(code))
    }
  },
  setGroups(state, payload) {
    state.groups = payload
  },
  setGroupMembers(state, payload) {
    console.warn('setGroupMembers')
    const data = payload.data.data.me.relationships?.socialGroups
    for (let i = 0; i < data.length; i++) {
      state.groupMembers.push({
        groupEntityUuid: data[i].entityUuid,
      })
      if (data[i]?.relationships?.hasMember) {
        const x = data[i]?.relationships?.hasMember
        state.groupMembers[i].members = []
        for (let j = 0; j < x.length; j++) {
          state.groupMembers[i].members.push({
            entityUuid: x[j].entityUuid,
            name: x[j].name,
            meta: JSON.parse(x[j].meta),
          })
        }
      }
    }
  },
  clearGroups(state) {
    state.groups = []
  },
}

export const actions = {
  cacheToStore(context, payload) {
    // payload =         {
    //  "key": str,     # entity UUID + this value will be the key combination used for retrieval
    //  "value":{...}   # entire payload is stored for this value,
    //  "ttl": 240      # time in seconds to live, if absent defaults to one hour (3600), if 0 will not expire
    // }
    this.$axios.put('/CACHE_URL/user', payload)
  },
  async loadFromStore(context, key) {
    let response
    try {
      response = await this.$axios.post(`/CACHE_URL/user`, {
        key,
      })
    } catch (error) {
      console.log(`Error: loadFromStore: ${error}`)
    }

    if (response?.data) {
      response.data = this.$JSON5.parse(response.data)
    }

    return response
  },
  triggerClearGroups(context) {
    context.commit('clearGroups')
  },
  redirect(context, url) {
    this.$router.push({
      path: url,
    })
  },
  notYetImplemented(context) {
    Dialog.alert("This feature isn't ready yet.")
  },
  async loadInviteGroupSearch(context, args) {
    const code = args.code
    const slug = args.slug
    // retrieves code and slug for new member invite
    try {
      context.commit('setLoading', {
        key: 'loadInviteGroupSearch',
        value: true,
      })
      const graphQuery = await getGraphql('query-invite-group-search.graphql')
      const query = graphQuery
        .replace('{slug}', slug)
        .replace('{code}', code.toUpperCase())
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
      })
      context.commit('setInviteGroupSearchResponse', response.data)
    } catch (error) {
      console.log('error searching', error)
    } finally {
      context.commit('setLoading', {
        key: 'loadInviteGroupSearch',
        value: false,
      })
    }
  },
  async loadSocial(context) {
    try {
      context.commit('setLoading', { key: 'loadSocial', value: true })
      context.commit('setLoading', { key: 'loadSocialCache', value: true })
      context.dispatch('loadFromStore', 'social__loadSocial').then((x) => {
        console.log('loadFromStore x', x)
        if (x?.data) {
          context.commit('setSocialResponse', x.data)
        }
        context.commit('setLoading', { key: 'loadSocialCache', value: false })
      })

      const query = await getGraphql('query-get-social-groups.graphql')
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
      })
      console.log('setSocialResponse', response.data)
      context.commit('setSocialResponse', response.data)
      context.dispatch('cacheToStore', {
        key: 'social__loadSocial',
        value: this.$JSON5.stringify(response.data),
        ttl: 604800, // one week
      })
    } catch (error) {
      console.log('error loadSocial', error)
    } finally {
      context.commit('setLoading', { key: 'loadSocial', value: false })
    }
  },
  async getGroups(context) {
    // deprecated
    console.warn('getGroups')
    context.commit('setLoading', { key: 'getGroups', value: true })
    try {
      const query = await getGraphql('query-get-social-groups.graphql')
      const response = await this.$axios.post('/GRAPHQL_URL/', {
        query,
      })
      // use social groups relation
      const userGroupsArray = response.data.data.me.relationships?.socialGroups
      // Parse meta.  It comes back double-escaped. :(
      userGroupsArray.forEach((group) => {
        group.meta = parseIt(group.meta, this)
        group.cadence = group?.meta?.cadence
        group.purpose = group?.meta?.purpose
        group.currentGroup = group.meta.phone_book

        // Parse meta.  It comes back double-escaped. :(
        const groupMembers = {}

        group.relationships.hasMember.forEach((member) => {
          member.meta = parseIt(member.meta, this)
          groupMembers[member.entityUuid] = getUserNameFromGroupMember(member)
        })

        // get latest posts
        group.contributions.forEach((item) => {
          item.type = 'contribution'
          const itemDate = new Date(item.dateCreated)
          const itemDateUtc = new Date(`${itemDate.toString()} UTC`)
          item.tstamp = itemDateUtc
          item.createdByEntityUserName = groupMembers[item.entityUuid]
          item.postUuid = item.socialContributionUuid
        })
        group.asks.forEach((item) => {
          item.type = 'ask'
          const itemDate = new Date(item.dateCreated)
          const itemDateUtc = new Date(`${itemDate.toString()} UTC`)
          item.tstamp = itemDateUtc
          item.createdByEntityUserName = groupMembers[item.entityUuid]
          item.postUuid = item.socialAskUuid
        })

        // combine asks and contributions and sort by tstamp
        group.latestPosts = [...group.contributions.concat(group.asks)].sort(
          (a, b) => b.tstamp - a.tstamp
        )
        for (let i = 0; i < group.latestPosts.length; i++) {
          group.latestPosts[i].createdByEntityUserName =
            groupMembers[group.latestPosts[i].createdByEntityUuid]
        }
      })

      if (response.status === 200) {
        context.commit('setGroups', userGroupsArray)
      } else {
        context.commit('setGroups', [])
      }
    } catch (error) {
      context.commit('setGroups', [])
    } finally {
      context.commit('setLoading', { key: 'getGroups', value: false })
    }
  },
  async addAsk(context, args) {
    context.commit('clearGroupUpdateStatus')
    const query = await getGraphql('mutation-add-ask.graphql')
    const optionChoice =
      args.option === 'other' && args.option_other
        ? args.option_other
        : args.option
    const variables = {
      entityArgs: {
        text: args.text.replace("'", "'"), //eslint-disable-line
        contact: args.contact.replace("'", "'"), //eslint-disable-line
        createdByEntityUuid: context.rootState.fiiAuth.identity.entityUuid,
        groupEntityUuid: args.groupEntityUuid,
        option: optionChoice,
        dateCreated: new Date().toISOString(),
        status: 'ACTIVE',
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        context.commit('setGroupUpdateStatus', true)
      }
      console.log('response to adding ask', response)
    } catch (error) {
      console.log('ERROR for addAsk', error)
    }
  },
  async addContribution(context, args) {
    let query = null
    if (args.type === 'ask') {
      query = await getGraphql('mutation-add-ask.graphql')
    } else if (args.type === 'contribution') {
      query = await getGraphql('mutation-add-contribution.graphql')
    } else {
      return null
    }
    const variables = {
      entityArgs: {
        text: args.text.replace("'", "'"), //eslint-disable-line
        createdByEntityUuid: context.rootState.fiiAuth.identity.entityUuid,
        groupEntityUuid: args.group_entity_uuid,
        option: args.option,
        dateCreated: new Date().toISOString(),
        status: 'ACTIVE',
        contact: '',
        groupName: args.groupName,
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        console.log('success')
      }
      console.log('response to adding contribution', response)
    } catch (error) {
      console.log('ERROR for addContribution', error)
    }
  },
  async updateGroup(context, args) {
    const query = await getGraphql('mutation-update-group.graphql')
    const variables = {
      entityArgs: {
        entityUuid: args.entityUuid,
        purpose:
          args.purpose && args.purpose.length ? this.$escape(args.purpose) : '',
        cadence: args?.cadence,
        groupIntentions:
          args.group_intentions && args.group_intentions.length
            ? this.$escape(args.group_intentions)
            : '',
        name: this.$escape(args.name),
        dateUpdated:
          args.dateUpdated !== null && args.dateUpdated !== undefined
            ? args.dateUpdated.replace('T', ' ')
            : 'None',
      },
    }
    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        // refresh groups
        // await context.dispatch('getGroups')
        // context.commit('setNewSlug', response.data.data.me.entity.updateGroup.slug)
        await context.dispatch('loadSocial')
        return response.data.data.me.entity.updateGroup.slug
      }
    } catch (error) {
      console.log('UPDATE group error ', error)
    }
  },

  // DEPRECATED: use the join action from the "groups" store.
  async joinGroup(context, args) {
    const query = await getGraphql('mutation-add-group-member.graphql')
    const variables = {
      txa: {
        sourceEntityUuid: context.rootState.fiiAuth.identity.entityUuid,
        targetEntityUuid: context.getters.inviteGroup.entityUuid,
        relationshipType: 'member_of',
        sourceEntityType: 'individual',
        targetEntityType: 'group',
        groupName: args.groupName,
      },
    }
    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        // consume invite
        await context.dispatch('consumeInvite', {
          code: args.code,
          status: 'CONSUMED',
          is_consumed: 'TRUE',
        })
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log('error with joining group ', error)
      return false
    }
  },

  // DEPRECATED: no longer needed as it's part of the groups store.
  async consumeInvite(context, args) {
    const query = await getGraphql('mutation-consume-invite-code.graphql')
    const variables = {
      entityArgs: {
        code: args.code,
        isConsumed: args.is_consumed,
        status: args.status,
        inviteeEntityUuid: context.rootState.fiiAuth.identity.entityUuid,
      },
    }
    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      console.log('response consume invite ', response)
    } catch (error) {
      console.log('error with consuming invite ', error)
    }
  },
  async createGroup(context, group) {
    const query = await getGraphql('mutation-create-group.graphql')
    const variables = {
      entityArgs: {
        name: this.$escape(group.name),
        joinGroup: true,
        meta: JSON.stringify({
          purpose:
            group.purpose && group.purpose.length
              ? this.$escape(group.purpose)
              : '',
          cadence: group?.cadence,
          group_intentions:
            group.group_intentions && group.group_intentions.length
              ? this.$escape(group.group_intentions)
              : '',
        }),
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        // await context.dispatch('getGroups')
        // refresh groups
        await context.dispatch('loadSocial')
        return response.data.data.me.entity.createGroup.slug
      }
    } catch (error) {
      console.log('Error creating group,', error)
    }
  },
  async leaveGroup(context, args) {
    const query = await getGraphql('mutation-leave-group.graphql')
    const relationshipId = args.relationshipId

    try {
      const variables = {
        relationshipId,
        txa: {
          sourceEntityType: 'individual',
          targetEntityType: 'group',
        },
      }
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      console.log('leaveGroup response ', response)
      if (response.status === 200) {
        context.commit('removeGroup', args.groupSlug)
      }
      console.log('leave user', response)
    } catch (e) {
      console.log('error removing user', e)
    }
  },
  async archiveAsk(context, socialAskUuid) {
    const query = await getGraphql('mutation-update-ask.graphql')
    const variables = {
      entityArgs: {
        socialAskUuid,
        askStatus: 'INACTIVE',
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        console.log('success')
      }
    } catch (error) {
      console.info(error)
    }
  },
  async archiveContribution(context, socialContributionUuid) {
    const query = await getGraphql('mutation-update-contribution.graphql')
    const variables = {
      entityArgs: {
        socialContributionUuid,
        contributionStatus: 'INACTIVE',
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      if (response.status === 200) {
        context.commit('setGroupUpdateStatus', true)
      }
      console.log('response to archiving contribution', response)
    } catch (error) {
      console.log('ERROR for archiving contribution', error)
    }
  },
  async updateAsk(context, args) {
    const query = await getGraphql('mutation-update-ask.graphql')
    const optionChoice =
      args.option === 'other' && args.option_other
        ? args.option_other
        : args.option
    const variables = {
      entityArgs: {
        socialAskUuid: args.uuid,
        text: args.text,
        option: optionChoice,
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      console.log('response to archiving ask', response)
    } catch (error) {
      console.log('ERROR for archiving Ask', error)
    }
  },
  async updateContribution(context, args) {
    const query = await getGraphql('mutation-update-contribution.graphql')
    const optionChoice =
      args.option === 'other' && args.option_other
        ? args.option_other
        : args.option
    const variables = {
      entityArgs: {
        socialContributionUuid: args.uuid,
        text: args.text,
        option: optionChoice,
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      console.log('response to updating contribution', response)
    } catch (error) {
      console.log('ERROR for updating contribution', error)
    }
  },

  // DEPRECATED. THIS IS PART OF THE GROUPS STORE NOW.
  async createInviteCode(context, args) {
    const query = await getGraphql('mutation-create-invite-code.graphql')
    context.commit('clearInvite')

    context.commit('setLoading', { key: 'createInviteCode', value: true })
    const currentGroup = context.getters.groupBySlug(args)
    const variables = {
      entityArgs: {
        inviteTypeName: 'SOCIAL_GROUP',
        createdByEntityUuid: context.rootState.fiiAuth.identity.entityUuid,
        invitedToEntityUuid: currentGroup.entityUuid,
        data: JSON.stringify({
          msg: `${context.rootState.auth.user.name}`,
          group_name: currentGroup.name,
          group_description: currentGroup.purpose,
          group_cadence: currentGroup?.cadence,
        }),
      },
    }

    try {
      const response = await this.$axios.post(context.state.GRAPHQL_URL, {
        query,
        variables,
      })
      console.log('CREATE invite code Response', response)
      if (response.status === 200) {
        context.commit('setNewInvite', response)
      }
    } catch (error) {
      console.log('Error creating group,', error)
    } finally {
      context.commit('setLoading', { key: 'createInviteCode', value: false })
    }
  },
  async notify(context, args) {
    let notificationSuccess = true
    const url = context.state.NOTIFICATIONS_URL + 'user/notifications' // TBD : landing zone implementation to be worked

    context.commit('setLoading', {
      key: 'sendNotification',
      value: true,
    })
    try {
      let payload =
        args.memberUuids && args.memberUuids.length > 0
          ? `{"sender_entity_uuid": "${args.entityUuid}", "recipients": ${args.memberUuids}, "category": "group_notifications", "notifications": ${args.notifications}}`
          : `{"sender_entity_uuid": "${args.entityUuid}", "recipients": ${args.recipients}, "notifications": ${args.notifications}}`
      payload = JSON.parse(payload)

      await this.$axios.$post(url, payload)
    } catch (error) {
      console.log('error sending email', error)
      notificationSuccess = false
    } finally {
      context.commit('setLoading', {
        key: 'sendNotification',
        value: false,
      })
    }
    return notificationSuccess
  },
  async sendNotification(context, notificationPayload) {
    /*
      notificationPayload object
      {
        entityUuid: string - sender uuid <required>,
        groupSlug: string <optional>,
        codeText: string <optional>,
        token: string - sender auth token <required>,
        ugc: boolean <optional>,
        phone: string <optional>,
        email: string <optional>
        smsContent: string <required if notification is sms>,
        subjectLine: string <required if notification is email>,
        emailContent: string <required if notification is email>,
        url: string <optional>
      }

      if the groupSlug is present, the notification is sent to all the members in the group
      if not, it is sent to the phone/email in the payload
    */
    const recipients = []
    const memberUuids = []
    const content = []

    const addRecipient = (payload) => {
      if (payload.email) {
        recipients.push({
          email: payload.email,
          language: 'en',
          variables: {
            name: payload.entityUuid,
          },
        })
      } else {
        recipients.push({
          phone: '1' + payload.phone,
          language: 'en',
          variables: {
            name: payload.entityUuid,
          },
        })
      }
    }

    // if group slug is present, send the notification to all the members in the group
    if (notificationPayload.groupSlug) {
      for (let i = 0; i < notificationPayload.members.length; i++) {
        // skip the notification to the sender
        if (
          notificationPayload.members[i].entityUuid ===
          notificationPayload.entityUuid
        ) {
          continue
        }

        memberUuids.push(notificationPayload.members[i].entityUuid)

        // const email = members[i]?.meta?.groupNotifications.email ? members[i]?.meta?.email : undefined
        // const phone = members[i]?.meta?.groupNotifications.phone ? members[i]?.meta?.phone : undefined

        // if (email) {
        //   addRecipient({ email, entityUuid: notificationPayload.entityUuid })
        // } else if (phone) {
        //   addRecipient({ phone, entityUuid: notificationPayload.entityUuid })
        // }
      }

      notificationPayload.category = 'group_notifications'
    } else if (notificationPayload.phone || notificationPayload.email) {
      if (notificationPayload.phone)
        addRecipient({
          phone: notificationPayload.phone,
          entityUuid: notificationPayload.entityUuid,
        })
      if (notificationPayload.email)
        addRecipient({
          email: notificationPayload.email,
          entityUuid: notificationPayload.entityUuid,
        })
    }

    if (recipients.length > 0 || memberUuids.length > 0) {
      if (notificationPayload.emailContent) {
        // escape html and hydrate escaped <br> tags
        const escapedMessage = escapeHTML(notificationPayload.emailContent)
        let message = ''

        if (notificationPayload.url) {
          if (notificationPayload.url.startsWith('/'))
            message = this.$formatLink(escapedMessage, notificationPayload.url)
          else
            message =
              escapedMessage +
              '<a href="' +
              notificationPayload.url +
              '">' +
              notificationPayload.url +
              '</a>'
        } else {
          message = escapedMessage
        }
        content.push({
          message: {
            en: {
              body: {
                formatted: message,
                text: message,
              },
              subject: notificationPayload.subjectLine,
            },
            es: {
              body: {
                formatted: message,
                text: message,
              },
              subject: notificationPayload.subjectLine,
            },
          },
          type: 'email',
        })
      }

      if (notificationPayload.smsContent) {
        // if (notificationPayload.smsContent.length + notificationPayload.codeText.length + 2 < 160) {
        content.push({
          message: {
            en: {
              body: notificationPayload.smsContent,
            },
            es: {
              body: notificationPayload.smsContent,
            },
          },
          type: 'sms',
        })
      }

      if (recipients.length > 0)
        notificationPayload.recipients = JSON.stringify(recipients)
      if (memberUuids.length > 0)
        notificationPayload.memberUuids = JSON.stringify(memberUuids)

      notificationPayload.notifications = JSON.stringify(content)

      return await context.dispatch('notify', notificationPayload)
    }
  },
}

export const getters = {
  groups: (state) => {
    // return []
    const g = state.loadSocialResponse?.data?.me?.relationships?.socialGroups
    if (!g) {
      return []
    }
    return g.filter((x) => x?.meta?.cadence)
  },
  inviteGroup: (state) => {
    return state.inviteGroupSearchResponse?.data.me.socialGroupSearch
  },
  inviteCode: (state) => {
    return state.inviteGroupSearchResponse?.data.me.socialInviteCodeSearch
  },
  loading: (state) => {
    return state.loading.length !== 0
  },
  getUuidBySlug: (state, getters) => (slug) => {
    const groups = getters.groups
    for (let i = 0; i < groups.length; i++) {
      if (groups[i].slug === slug) {
        return groups[i].entityUuid
      }
    }
  },
  currentInviteCountPerGroup: (state) => (groupuuid, uuid) => {
    let count = 0
    if (state.invites && state.invites.length) {
      const arr = state.invites
      for (let i = 0; i < arr.length; i++) {
        if (
          arr[i].invited_to_entity_uuid === groupuuid &&
          arr[i].invitee_entity_uuid.length &&
          arr[i].invitee_entity_uuid !== uuid
        ) {
          count += 1
        }
      }
    }
    return count
  },
  groupBySlug: (state, getters) => (groupSlug) => {
    try {
      console.warn('groupSlug', groupSlug)
      const groups = getters.groups

      return groups.find((group) => group.slug === groupSlug)
    } catch (error) {
      return undefined
    }
  },
  groupByEntityUuid: (state, getters) => (entityUuid) => {
    try {
      const groups = getters.groups

      console.warn('entityUuid', entityUuid)
      return groups.find((group) => group.entityUuid === entityUuid)
    } catch (error) {
      return undefined
    }
  },
  getGroupMemberCount: (state, getters) => (groupSlug) => {
    // get the number of members in the group
    try {
      const groups = getters.groups

      const group = groups.find((group) => group.slug === groupSlug)

      const members = group.relationships.hasMember.filter(
        (x) => x.entityType === 'individual'
      )
      return members.length
    } catch (error) {
      return undefined
    }
  },
  getGroupMembers: (state, getters) => (groupSlug) => {
    // get the number of members in the group
    try {
      const groups = getters.groups

      const group = groups.find((group) => group.slug === groupSlug)

      return group.relationships.hasMember.filter(
        (x) => x.entityType === 'individual'
      )
    } catch (error) {
      return undefined
    }
  },
  groupMember: (state, getters) => (entityUuid, groupSlug) => {
    const groups = getters.groups
    const group = groups.find((group) => group.slug === groupSlug)

    const foundMember = group.relationships.hasMember.find(
      (x) => x.entityUuid === entityUuid
    )
    if (foundMember) {
      return foundMember
    } else return undefined
  },
  getGroupMemberName:
    (state, getters, rootState) => (entityUuid, groupSlug) => {
      // get the first name of a member
      const groups = getters.groups
      const group = groups.find((group) => group.slug === groupSlug)
      const foundMember = group.relationships.hasMember.find(
        (x) => x.entityUuid === entityUuid
      )
      if (foundMember && foundMember.meta.first_name) {
        return foundMember.meta.first_name
      } else {
        return 'member'
      }
    },
  getUnusedCodesForGroup: (state, getters) => (groupSlug) => {
    const groups = getters.groups
    const group = groups.find((group) => group.slug === groupSlug)
    const result = []
    const codes = state.invites
    const groupUuid = group.entityUuid
    for (let i = 0; i < codes.length; i++) {
      if (
        codes[i].invited_to_entity_uuid === groupUuid &&
        codes[i].is_consumed === 'false'
      ) {
        result.push(codes[i])
      }
    }
    return result
  },
}
